import { render } from "./Pixeon.vue?vue&type=template&id=9f3140bc&scoped=true"
import script from "./Pixeon.vue?vue&type=script&lang=js"
export * from "./Pixeon.vue?vue&type=script&lang=js"

import "./Pixeon.vue?vue&type=style&index=0&id=9f3140bc&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f3140bc"]])

export default __exports__